"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./FlyingLetter.scss");
require("./FlyingLetter.mobile.scss");
var FLYING_LETTER = 'T';
var FlyingLetter = /** @class */ (function (_super) {
    __extends(FlyingLetter, _super);
    function FlyingLetter(props) {
        var _this = _super.call(this, props) || this;
        _this.setFromElement = _this.setFromElement.bind(_this);
        _this.setToElement = _this.setToElement.bind(_this);
        _this.setContainerElement = _this.setContainerElement.bind(_this);
        return _this;
    }
    // componentDidMount() {
    //   // TODO: Set the Letter Opacity to 0 before RAF, set it to one onside the RAF
    //   requestAnimationFrame(() => {
    //     requestAnimationFrame(() => {
    //       const left = this.letterFromElement.offsetLeft;
    //       const width = this.letterToElement.offsetLeft - left;
    //       this.letterContainerElement.setAttribute('style', `left:${left}px; width: ${width}px;`);
    //     });
    //   });
    // }
    FlyingLetter.prototype.render = function () {
        return (React.createElement("div", { className: styles.flyingContainer },
            React.createElement("div", { className: styles.firstWord }, "AT&T")));
    };
    FlyingLetter.prototype.setFromElement = function (el) {
        this.letterFromElement = el;
    };
    FlyingLetter.prototype.setToElement = function (el) {
        this.letterToElement = el;
    };
    FlyingLetter.prototype.setContainerElement = function (el) {
        this.letterContainerElement = el;
    };
    return FlyingLetter;
}(React.Component));
exports.default = FlyingLetter;
//# sourceMappingURL=FlyingLetter.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/common/Loader/FlyingLetter/FlyingLetter.js
// module id = 663
// module chunks = 8